import { render, staticRenderFns } from "./addLicense.vue?vue&type=template&id=7b45bea2&scoped=true"
import script from "./addLicense.vue?vue&type=script&lang=js"
export * from "./addLicense.vue?vue&type=script&lang=js"
import style0 from "./addLicense.vue?vue&type=style&index=0&id=7b45bea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b45bea2",
  null
  
)

export default component.exports